import { ContentBlock } from "@/components/ContentBlock/ContentBlock";
import TextBlock from "@/components/TextBlock/TextBlock";
import { htmlify } from "@/services/utils";
import type { FundDetailLayoutComponentProps } from "@/types/fundDetailLayout";

export const FxObjectivePanel = ({ dashboard, flex }: FundDetailLayoutComponentProps) => {
	const { fxObjectivePanel: props } = dashboard;

	if (!props) {
		return null;
	}

	const { heading, tooltip, ...remainingProps } = props;

	return (
		<ContentBlock
			id="fxObjectivePanel"
			data-testid="FxObjectivePanel"
			flex={flex}
			heading={htmlify(heading)}
			tooltip={htmlify(tooltip)}
			tabIndex={-1}
		>
			<TextBlock {...remainingProps} />
		</ContentBlock>
	);
};
